import type { CSSProperties, ImgHTMLAttributes } from "react";

type ImageInput = string | { src: string; width?: number; height?: number };

export type StaticImageData = { src: string; width?: number; height?: number };

interface ImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "width" | "height"> {
  src: ImageInput;
  width?: number | string;
  height?: number | string;
  fill?: boolean;
  alt?: string;
}

export default function Image({ src, width, height, fill, alt = "", style, ...rest }: ImageProps) {
  const resolved = typeof src === "string" ? src : src.src;
  const finalStyle: CSSProperties = fill
    ? {
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        ...style,
      }
    : style ?? {};

  return (
    <img
      src={resolved}
      width={width}
      height={height}
      alt={alt}
      style={finalStyle}
      {...rest}
    />
  );
}
